import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DestroyedService extends Subject<boolean> implements OnDestroy {
  // TODO: add explicit constructor

  ngOnDestroy() {
    this.next(true);
    this.complete();
  }
}
